// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offboardpg-inline-1 {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 8px;
  align-items: center;
}

.offboardpg-inline-2 {
  margin-top: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  padding: 10px;
  font-size: 12px;
}

.offboardpg-inline-3 {
  font-weight: 700;
  margin-bottom: 4px;
}

.offboardpg-inline-4 {
  margin-top: 8px;
  font-size: 12px;
  color: #64748b;
}

.offboardpg-inline-5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.offboardpg-inline-6 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.offboardpg-inline-7 {
  min-width: 240px;
  height: 34px;
}

.offboardpg-inline-8 {
  padding: 0;
  overflow-x: auto;
}

.offboardpg-inline-9 {
  font-family: monospace;
  font-size: 11px;
}

.offboardpg-inline-10 {
  font-weight: 600;
}

.offboardpg-inline-11 {
  display: flex;
  gap: 4px;
}

.offboardpg-inline-12 {
  font-size: 10px;
  padding: 3px 8px;
}

.offboardpg-inline-13 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
}

.offboardpg-inline-14 {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 4px;
}

.offboardpg-inline-15 {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 4px;
}

.offboardpg-inline-16 {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 4px;
}

.offboardpg-inline-17 {
  display: flex;
  gap: 8px;
}

.offboardpg-inline-18 {
  margin-top: 8px;
}

.offboardpg-inline-19 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.offboardpg-inline-20 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px solid #f1f5f9;
}

.offboardpg-inline-21 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.offboardpg-inline-22 {
  padding: 2px 6px;
  font-size: 9px;
}

.offboardpg-inline-23 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px solid #f1f5f9;
}

.offboardpg-inline-24 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.offboardpg-inline-25 {
  padding: 2px 6px;
  font-size: 9px;
}

.offboardpg-inline-26 {
  border-top: 2px solid #e2e8f0;
  margin-top: 12px;
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.offboardpg-inline-27 {
  font-size: 14px;
  font-weight: 700;
}

.offboardpg-inline-28 {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.offboardpg-inline-29 {
  font-weight: 600;
}

.offboardpg-inline-30 {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.offboardpg-inline-31 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 12px;
}

.offboardpg-dyn-1 {
  color: var(--offboardpg-1-color);
  font-size: 12px;
}

.offboardpg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--offboardpg-2-color);
}

.offboardpg-dyn-3 {
  text-align: center;
  padding: 40px;
  color: var(--offboardpg-3-color);
}

.offboardpg-dyn-4 {
  background: var(--offboardpg-4-background);
  border: 1px solid #c7d2fe;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 14px;
  text-align: center;
}

.offboardpg-dyn-5 {
  font-size: 11px;
  color: var(--offboardpg-5-color);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.offboardpg-dyn-6 {
  font-family: 'Outfit',sans-serif;
  font-size: 28px;
  font-weight: 800;
  color: var(--offboardpg-6-color);
  margin-top: 4px;
}

.offboardpg-dyn-7 {
  font-size: 11px;
  color: var(--offboardpg-7-color);
  margin-top: 4px;
}

.offboardpg-dyn-8 {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--offboardpg-8-color);
}

.offboardpg-dyn-9 {
  font-size: 12px;
  color: var(--offboardpg-9-color);
}

.offboardpg-dyn-10 {
  font-size: 12px;
  font-weight: 600;
  color: var(--offboardpg-10-color);
}

.offboardpg-dyn-11 {
  font-size: 12px;
  font-weight: 700;
  margin-top: 12px;
  margin-bottom: 8px;
  color: var(--offboardpg-11-color);
}

.offboardpg-dyn-12 {
  font-size: 12px;
  color: var(--offboardpg-12-color);
}

.offboardpg-dyn-13 {
  font-size: 12px;
  font-weight: 600;
  color: var(--offboardpg-13-color);
}

.offboardpg-dyn-14 {
  font-family: 'Outfit',sans-serif;
  font-size: 20px;
  font-weight: 800;
  color: var(--offboardpg-14-color);
}

.offboardpg-dyn-15 {
  font-size: 11px;
  font-weight: 700;
  color: var(--offboardpg-15-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.offboardpg-dyn-16 {
  font-size: 11px;
  padding: 5px 0;
  border-bottom: 1px solid #f8fafc;
  color: var(--offboardpg-16-color);
}

.offboardpg-dyn-17 {
  color: var(--offboardpg-17-color);
}

.offboardpg-dyn-18 {
  color: var(--offboardpg-18-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/OffboardPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".offboardpg-inline-1 {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.offboardpg-inline-2 {\n  margin-top: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  padding: 10px;\n  font-size: 12px;\n}\n\n.offboardpg-inline-3 {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.offboardpg-inline-4 {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.offboardpg-inline-5 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.offboardpg-inline-6 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.offboardpg-inline-7 {\n  min-width: 240px;\n  height: 34px;\n}\n\n.offboardpg-inline-8 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.offboardpg-inline-9 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.offboardpg-inline-10 {\n  font-weight: 600;\n}\n\n.offboardpg-inline-11 {\n  display: flex;\n  gap: 4px;\n}\n\n.offboardpg-inline-12 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.offboardpg-inline-13 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.offboardpg-inline-14 {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.offboardpg-inline-15 {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.offboardpg-inline-16 {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.offboardpg-inline-17 {\n  display: flex;\n  gap: 8px;\n}\n\n.offboardpg-inline-18 {\n  margin-top: 8px;\n}\n\n.offboardpg-inline-19 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.offboardpg-inline-20 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.offboardpg-inline-21 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.offboardpg-inline-22 {\n  padding: 2px 6px;\n  font-size: 9px;\n}\n\n.offboardpg-inline-23 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.offboardpg-inline-24 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.offboardpg-inline-25 {\n  padding: 2px 6px;\n  font-size: 9px;\n}\n\n.offboardpg-inline-26 {\n  border-top: 2px solid #e2e8f0;\n  margin-top: 12px;\n  padding-top: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.offboardpg-inline-27 {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.offboardpg-inline-28 {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.offboardpg-inline-29 {\n  font-weight: 600;\n}\n\n.offboardpg-inline-30 {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.offboardpg-inline-31 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n\n.offboardpg-dyn-1 {\n  color: var(--offboardpg-1-color);\n  font-size: 12px;\n}\n\n.offboardpg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--offboardpg-2-color);\n}\n\n.offboardpg-dyn-3 {\n  text-align: center;\n  padding: 40px;\n  color: var(--offboardpg-3-color);\n}\n\n.offboardpg-dyn-4 {\n  background: var(--offboardpg-4-background);\n  border: 1px solid #c7d2fe;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 14px;\n  text-align: center;\n}\n\n.offboardpg-dyn-5 {\n  font-size: 11px;\n  color: var(--offboardpg-5-color);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.offboardpg-dyn-6 {\n  font-family: 'Outfit',sans-serif;\n  font-size: 28px;\n  font-weight: 800;\n  color: var(--offboardpg-6-color);\n  margin-top: 4px;\n}\n\n.offboardpg-dyn-7 {\n  font-size: 11px;\n  color: var(--offboardpg-7-color);\n  margin-top: 4px;\n}\n\n.offboardpg-dyn-8 {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: var(--offboardpg-8-color);\n}\n\n.offboardpg-dyn-9 {\n  font-size: 12px;\n  color: var(--offboardpg-9-color);\n}\n\n.offboardpg-dyn-10 {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--offboardpg-10-color);\n}\n\n.offboardpg-dyn-11 {\n  font-size: 12px;\n  font-weight: 700;\n  margin-top: 12px;\n  margin-bottom: 8px;\n  color: var(--offboardpg-11-color);\n}\n\n.offboardpg-dyn-12 {\n  font-size: 12px;\n  color: var(--offboardpg-12-color);\n}\n\n.offboardpg-dyn-13 {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--offboardpg-13-color);\n}\n\n.offboardpg-dyn-14 {\n  font-family: 'Outfit',sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: var(--offboardpg-14-color);\n}\n\n.offboardpg-dyn-15 {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--offboardpg-15-color);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n\n.offboardpg-dyn-16 {\n  font-size: 11px;\n  padding: 5px 0;\n  border-bottom: 1px solid #f8fafc;\n  color: var(--offboardpg-16-color);\n}\n\n.offboardpg-dyn-17 {\n  color: var(--offboardpg-17-color);\n}\n\n.offboardpg-dyn-18 {\n  color: var(--offboardpg-18-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
